import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../utils/apiStatus.enum";
import { UserState } from "../models/userModel";
import httpClient from "../../utils/httpClient";

export interface ResponseError {
  message: string;
}

export const getUserFrontendPermissions = createAsyncThunk<
  any,
  void,
  { rejectValue: ResponseError }
>("UserFrontendProfileSlice/getFrontendPermissions", async (_, thunkApi) => {
  try {
    const response = await httpClient.get("/user");
    if (response.status != 200 || response.data.Status !== "success") {
      if (response.data.Status == "error") {
        return thunkApi.rejectWithValue({
          message: response.data.Message,
        });
      } else {
        return thunkApi.rejectWithValue({
          message: "Failed to get user permissions.",
        });
      }
    }
    if (response.data) {
      return response.data;
    }
    return thunkApi.rejectWithValue({
      message: "Failed to get user permissions.",
    });
  } catch (error) {
    console.log("🚀 ~ error:", error);
    return thunkApi.rejectWithValue({
      message: "Failed to get user permissions.",
    });
  }
});



const initialState: UserState = {
  name: "",
  emailId: "",
  id: "",
  avatar: "",
  profileApiStatus: ApiStatus.NONE,
  profileApiError: "",
  userInfo: {},
  userPermissions: [],
  userPermissionsError: "",
  userPermissionsStatus: ApiStatus.NONE,
  userEntityData: []
};

const UserFrontendProfileSlice = createSlice({
  name: "UserFrontendProfileSlice",
  initialState,
  reducers: {
    resetUserProfile: (state) => {
      state.name = "";
      state.emailId = "";
      state.id = "";
      state.avatar = "";
      state.profileApiStatus = ApiStatus.NONE;
      state.profileApiError = "";
      state.userInfo = {};
      state.userPermissions = [];
      state.userPermissionsError = "";
      state.userPermissionsStatus = ApiStatus.NONE;
    },
  },
  extraReducers(builder) {
    builder.addCase(getUserFrontendPermissions.pending, (state) => {
      state.userPermissionsStatus = ApiStatus.LOADING;
    });
    builder.addCase(getUserFrontendPermissions.rejected, (state, { payload }) => {
      state.userPermissionsStatus = ApiStatus.ERROR;
      state.userPermissionsError = payload?.message.toString() || "";
    });
    builder.addCase(getUserFrontendPermissions.fulfilled, (state, { payload }) => {
      if (payload.Status == "error") {
        state.userPermissionsStatus = ApiStatus.ERROR;
        state.userPermissionsError = payload.Message;
      } else if (payload.Status == "success") {
        state.userPermissionsStatus = ApiStatus.SUCCESS;
        state.userPermissions = payload.Data.Roles;
        state.userEntityData = payload.Data.EntityData;
      }
    });
  },
});


export const { resetUserProfile } = UserFrontendProfileSlice.actions;
export default UserFrontendProfileSlice.reducer;
